// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  type: window.location.origin,
  //apiUrl: 'https://pairingproductapi-dev.azurewebsites.net/pairing-product/api',
  //apiUrl: 'https://pairingproductapi-qa.azurewebsites.net/pairing-product/api',
  apiUrl: `${document.location.protocol}//${document.location.host}/pairing-product/api`,
  auth: {
    domain: 'dev-c2oymhxblfvzum2l.eu.auth0.com',
    clientId: 'aMseTbLYAHdoaoxtj1amJYd9LUIkbkvb',
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: 'https://pairing-dev.azurewebsites.net',
    },
  },
  indusAuth: {
    domain: 'dacoval-qa.eu.auth0.com',
    clientId: 'aOeLlqVqwUy4YlvGqvdMwunkby8vCug0',
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: 'https://pairing-qa.azurewebsites.net',
    },
  },
  uatAuth: {
    domain: 'dacoval-dev.eu.auth0.com',
    clientId: 'NeaXeSZWKEN3RdO16aOtZjvJQUH0nYy0',
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: 'https://pairing-uat.azurewebsites.net',
    },
  },  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
